import { render, staticRenderFns } from "./consultation.vue?vue&type=template&id=3174f733&"
import script from "./consultation.vue?vue&type=script&lang=js&"
export * from "./consultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports